
import axios from "axios"

class Search {


    // 1. describe and create/initiate our object
    constructor() {
        this.addSearchHTML();
        this.resultsDivBlog = document.querySelector("#search-overlay__blogresults") //$("#search-overlay__blogresults");
        this.resultsDivPage = document.querySelector("#search-overlay__pageresults") //$("#search-overlay__pageresults");
        this.resultsDivCamp = document.querySelector("#search-overlay__campusresults") //$("#search-overlay__campusresults");
        this.resultsDivProf = document.querySelector("#search-overlay__profresults") //$("#search-overlay__profresults");
        this.resultsDivProg = document.querySelector("#search-overlay__progresults") //$("#search-overlay__progresults");
        this.resultsDivEvnt = document.querySelector("#search-overlay__evntresults") //$("#search-overlay__evntresults");
        this.openButton = document.querySelectorAll(".js-search-trigger");
        this.closeButton = document.querySelector(".search-overlay__close");
        this.searchOverlay = document.querySelector(".search-overlay");
        this.searchField = document.querySelector("#search-term");
        this.events();
        this.isOverlayOpen = false;
        this.isSpinnerVisible = false;
        this.previousValue;
        this.typingTimer;
        this.results = "";
        this.results2 = "";
    }

    //2. events
    
    events() {
        this.openButton.forEach(el => {
            el.addEventListener("click", e => {
                e.preventDefault()
                this.openOverlay()
            })
        })

        this.closeButton.addEventListener("click", () => this.closeOverlay())
        document.addEventListener("keydown", e => this.keyPressDispatcher(e))
        this.searchField.addEventListener("keyup", () => this.typingLogic())
    }

    //3. methods (function, action)
    typingLogic() {
        
        if (this.searchField.value != this.previousValue) {
            clearTimeout(this.typingTimer)

            if (this.searchField.value) {
                if (!this.isSpinnerVisible) {
                    this.resultsDivBlog.innerHTML = '<div class="spinner-loader"></div>'
                    this.isSpinnerVisible = true
                }
                this.typingTimer = setTimeout(this.getResults3.bind(this), 750)

            } else {
                this.clearPage();
                this.isSpinnerVisible = false
                
            }
        }

        this.previousValue = this.searchField.value
    }


    drawResultHTML(result, title) {
        return `
            <h2 class="search-overlay__section-title">${title}</h2>
                ${result.length ?
                `<ul class="link-list min-list">
                
                ${result.map(item => `
                    <li>
                    <a href="${item.link}"> ${item.permalink}</a> ${item.type == "post" ? `by <a href="${item._links.author[0].href}">  ${item.customField1} </a>` : ""}
                    </li>`
                ).join('')}

                    </ul>`
            : `No ${title.toLowerCase()} matches that results`}
            `
    }

    drawResultHTML3(result, title) {
        return `
            <h2 class="search-overlay__section-title">${title}</h2>
                ${result.length ?
                `<ul class="link-list min-list">
                
                ${result.map(item => `

                    ${item.type == "professor" ?  
                    `<li class="professor-card__list-item">
                    <a class="professor-card" href="${item.permalink}">
                      <img src="${item.image}" class="professor-card__image" \>
                      <span class="professor-card__name">${item.title}</span>
                    </a>
                    </li>`
                    : item.type == "event" ?
                        `
                     <div class="event-summary">
                        <a class="event-summary__date t-center" href="${item.permalink}">
                          <span class="event-summary__month">${item.eventMonth}</span>
                          <span class="event-summary__day">${item.eventDay}</span>
                        </a>
                        <div class="event-summary__content">
                          <h5 class="event-summary__title headline headline--tiny"><a href="${item.permalink}">${item.title}</a></h5>
                          <p>${item.excerpt}<br><a href="${item.permalink}" class="nu gray">Learn more</a></p>
                        </div>
                      </div>
                      `
                    : `<li><a href="${item.permalink}"> ${item.title}</a> ${item.type == "post" ? `by <a href="#">  ${item.authorName} </a>` : ""}</li>`
                    }

                    `
                ).join('')}

                    </ul>`
            : `No ${ title.toLowerCase() } matches that results.${ title == "Programs" || title == "Campuses" || title == "Events" ? ` <br \><a href="${universityData.root_url}/${title.toLowerCase()}">  View All ${title} </a>` : ""}`}
            `
    }

    async getResults3() {
         
        try {
            const response1 = await axios.get(universityData.root_url + "/wp-json/university/v1/search?s=" + this.searchField.value)
            const results1 = response1.data
            this.resultsDivBlog.innerHTML = this.drawResultHTML3(results1.post, "Blog Posts")
            this.resultsDivPage.innerHTML = this.drawResultHTML3(results1.page, "Pages")
            this.resultsDivProf.innerHTML = this.drawResultHTML3(results1.professor, "Professors")
            this.resultsDivProg.innerHTML = this.drawResultHTML3(results1.program, "Programs")
            this.resultsDivCamp.innerHTML = this.drawResultHTML3(results1.campus, "Campuses")
            this.resultsDivEvnt.innerHTML = this.drawResultHTML3(results1.event, "Events")
        } catch (e) {
            console.log(e)
        }
    }

    keyPressDispatcher(e) {
        if (e.keyCode == 83 && !this.isOverlayOpen && document.activeElement.tagName != "INPUT" && document.activeElement.tagName != "TEXTAREA") {
            this.openOverlay();
            
        }
        if (e.keyCode == 27 && this.isOverlayOpen) {
            this.closeOverlay();
            
        }
    }

    openOverlay() {
        this.searchOverlay.classList.add("search-overlay--active");
        document.body.classList.add("body-no-scroll");
        this.searchField.value = "";
        setTimeout(() => this.searchField.focus(), 301);
        //console.log("our open method just ran!");
        this.isOverlayOpen = true;
        return false;
    }

    closeOverlay() {
        this.searchOverlay.classList.remove("search-overlay--active");
        document.body.classList.remove("body-no-scroll");
        //console.log("our close method just ran!");
        this.isOverlayOpen = false;
        this.searchField.value='';
        this.clearPage();
    }
    

    addSearchHTML() {
        document.body.insertAdjacentHTML(
            "beforeend",
            `
            <div class="search-overlay">
                <div class="search-overlay__top">
                    <div class="container">
                        <i class="fa fa-search search-overlay__icon" aria-hidden="true"></i>
                        <input type="text" class="search-term" placeholder="What are you looking for?" id="search-term"/>
                        <i class="fa fa-window-close search-overlay__close" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="container">

                <div class="row">
                    <div class="one-third">
                    <div id="search-overlay__blogresults"></div>
                    <div id="search-overlay__pageresults"></div>
                    </div>
                    <div class="one-third">
                    <div id="search-overlay__progresults"></div>
                    <div id="search-overlay__profresults"></div>
                    </div>
                    <div class="one-third">
                    <div id="search-overlay__campusresults"></div>
                    <div id="search-overlay__evntresults"></div>
                    </div>
                </div>
                </div>
    
            </div>
        `)
    }
    clearPage() {
        this.resultsDivBlog.innerHTML = '';
        this.resultsDivPage.innerHTML = '';
        this.resultsDivCamp.innerHTML = '';
        this.resultsDivProf.innerHTML = '';
        this.resultsDivProg.innerHTML = '';
        this.resultsDivEvnt.innerHTML = '';
    }
}

export default Search